<template>
  <div id="appBackground" :class="{'signIn-page': isSignInPage, 'licenses-theme': isLicensesTheme}">
    <div v-if="enableSpecialEventBackground" class="show-animate-clouds"></div>
    <div id="gradientBackground" :class="{'is-visible': gradienBackgroundVisible}"></div>
    <div id="specialEvent" v-if="enableSpecialEventBackground" :class="[{'is-visible': specialEventBackground}]">
      <div v-if="specialEventBackground" class="video-container">
        <video id="specialEventBackgroundVideo" :ref="'specialEventBackgroundVideo'" autoplay name="specialEventBackgroundVideo" muted>
          <source :src="specialEventVideoLink" type="video/mp4">
        </video>
      </div>
    </div>
  </div>
</template>

<script src="./app-background.js"></script>
<style lang="scss" src="./app-background.scss"></style>
